import React from 'react';

import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { Modal } from 'ui-components/components/modal';
import { ModalBody } from 'ui-components/components/modal/modal-body';
import { ModalFooter } from 'ui-components/components/modal/modal-footer';
import { ModalFooterCancelButton } from 'ui-components/components/modal/modal-footer/cancel-button';
import { ModalHeader } from 'ui-components/components/modal/modal-header';
import { emptyArray } from 'ui-components/default-props/empty';

import { getWarehouseOrLocationOrToteErrorMessage } from '../../constants';
import { messages } from '../../messages';
import { InventoryWarehouseDeleteErrorPropType, InventoryLocationDeleteErrorPropType } from '../../prop-types';
import style from './error-modal.module.css';

export const ErrorModal = ({ errors = emptyArray, inventoryWarehouseName = '' }) => {
  return (
    <Modal size='small'>
      <ModalHeader>
        <FormattedMessage {...messages.errorModalTitle} />
      </ModalHeader>
      <ModalBody className={style.body}>
        {inventoryWarehouseName && (
          <FormattedMessage
            {...messages.inventoryWarehouseDeleteErrorNotificationHeader}
            values={{ warehouseName: inventoryWarehouseName }}
          />
        )}
        <ul className={style['warehouse-delete-error-code-list']}>
          {errors.map((error) => (
            <li key={error}>{getWarehouseOrLocationOrToteErrorMessage(error)}</li>
          ))}
        </ul>
        {inventoryWarehouseName && <FormattedMessage {...messages.inventoryWarehouseDeleteErrorNotificationFooter} />}
      </ModalBody>
      <ModalFooter>
        <ModalFooterCancelButton />
      </ModalFooter>
    </Modal>
  );
};

ErrorModal.propTypes = {
  errors: PropTypes.oneOfType([
    PropTypes.arrayOf(InventoryWarehouseDeleteErrorPropType),
    PropTypes.arrayOf(InventoryLocationDeleteErrorPropType),
  ]),
  inventoryWarehouseName: PropTypes.string,
  onClose: PropTypes.func.isRequired,
};
